import { Component, Input, OnInit } from '@angular/core';
import { ColDef } from 'ag-grid-community';
import { AgGridImportCommonDuplicatesTab } from '../../../../components/import-documents/pages/duplicates-tab/duplicates-tab.model';
import { AgGridI } from '../../ag-grid/ag-grid.model';
import { CommonService } from '../../../services/common.service';
import { TabsService } from '../../tabs/tabs.service';

@Component({
  selector: 'app-common-duplicate-tab',
  templateUrl: './common-duplicate-tab.component.html',
  styleUrls: ['./common-duplicate-tab.component.scss']
})
export class CommonDuplicateTabComponent implements OnInit {
  @Input() potentialError: boolean = false;
  @Input() importError:boolean = false;
  isLoading: boolean = false;
  flexHeight;
  dataModel: AgGridI;
   gridApi;
   gridColumnApi;

  public defaultColDef: ColDef = {
    resizable: true,
    maxWidth:350
  };
  overlayNoRowsTemplate = '<div class="ag-overlay-no-rows-center">No Records Available</div>';
  @Input() data:any = {}

  constructor(public commonService : CommonService,public tabsService: TabsService,) { 
  }

  ngOnInit(): void {
    this.tabsService.onSubNavChanged.subscribe((url=>{
      if(url!== undefined){
        this.dataModel = this.data?.duplicateData?.dataModel??AgGridImportCommonDuplicatesTab;
      }
    }));


    this.dataModel = this.data?.duplicateData?.dataModel??AgGridImportCommonDuplicatesTab;
    this.data.duplicateData = this.data?.duplicateData??{};
    this.data.duplicateData ={
      ...this.data.duplicateData,
      rowData: this.data.duplicateData?.rowData ?? []
    }
  }
  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

}
